import type {Component} from 'solid-js';
import {ErrorBoundary} from "solid-js";

import {Route, Router, Routes} from "@solidjs/router";
import './gui/styles.less';
import {routes} from "./logic/routes";
import Footer from "./gui/components/Footer";
import ErrorBoundaryFallback from "./gui/components/ErrorBoundaryFallback";

const App: Component = () => {
    return <>
        <ErrorBoundary fallback={(err, reset) => <ErrorBoundaryFallback error={err} reset={reset}/>}>
            <Router>
                <div id={"main"}>
                    <ErrorBoundary fallback={(err, reset) => <ErrorBoundaryFallback error={err} reset={reset}/>}>
                        <Routes>
                            <>
                                {Object.values(routes).map(it =>
                                    <Route path={it.path} component={it.component}/>
                                )}
                            </>
                        </Routes>
                    </ErrorBoundary>
                </div>
                <Footer/>
            </Router>
        </ErrorBoundary>
    </>
};

export default App;
